"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthashConsensus = exports.CliqueConsensus = exports.CasperConsensus = exports.Blockchain = void 0;
var blockchain_1 = require("./blockchain");
Object.defineProperty(exports, "Blockchain", { enumerable: true, get: function () { return blockchain_1.Blockchain; } });
var consensus_1 = require("./consensus");
Object.defineProperty(exports, "CasperConsensus", { enumerable: true, get: function () { return consensus_1.CasperConsensus; } });
Object.defineProperty(exports, "CliqueConsensus", { enumerable: true, get: function () { return consensus_1.CliqueConsensus; } });
Object.defineProperty(exports, "EthashConsensus", { enumerable: true, get: function () { return consensus_1.EthashConsensus; } });
__exportStar(require("./utils"), exports);
//# sourceMappingURL=index.js.map